import type { DocumentCategory } from '@immo/api-contract';
import type { EnumTranslation } from '../types';

export const DOCUMENT_CATEGORY_LABELS = {
  EXPOSE: 'Exposé',
  FLOOR_PLAN: 'Floor plan',
  SITE_PLAN: 'Site plan',
  LIVING_AREA_CALCULATION: 'Living/usable area calculation',
  ENERGY_CERTIFICATE: 'Energy certificate',
  MAINTENANCE_RECORD: 'Maintenance record',
  TECHNICAL_REPORT: 'Technical report / expert opinion',
  LAND_REGISTER_EXTRACT: 'Land register extract',
  CADASTRAL_MAP: 'Cadastral map',
  BUILDING_ENCUMBRANCE: 'Building encumbrance disclosure',
  CONTAMINATED_SITES_REGISTER_EXTRACT: 'Contaminated sites register extract',
  DECLARATION_OF_DIVISION: 'Declaration of division',
  PARTITION_PLAN: 'Partition plan',
  CERTIFICATE_OF_COMPLETENESS: 'Certificate of completeness',
  HERITABLE_BUILDING_RIGHT: 'Heritable building right',
  BUILDING_PERMIT: 'Building permit',
  BUILDING_DESCRIPTION: 'Building description',
  BUILDING_FILE: 'Building file / plans',
  HERITAGE_PROTECTION: 'Monument protection certificate',
  RENOVATION_RECORD: 'Renovation/modernisation record',
  OWNERS_MEETING_MINUTES: 'Owners meeting minutes',
  RESOLUTION_COLLECTION: 'Resolution collection',
  ECONOMIC_PLAN: 'Economic plan',
  HOA_STATEMENT: 'House money statement',
  PROPERTY_MANAGEMENT_CONTRACT: 'Administrator contract',
  RENTAL_CONTRACT: 'Rental contract',
  UTILITY_STATEMENT: 'Utility bill statement',
  TENANT_LIST: 'Tenant list',
  RESIDENCE_CONFIRMATION: 'Landlord confirmation of residence',
  HOUSE_RULES: 'House rules',
  BROKER_CONTRACT: 'Broker contract',
  RESERVATION_AGREEMENT: 'Reservation agreement',
  PURCHASE_CONTRACT: 'Purchase / notary contract',
  HANDOVER_PROTOCOL: 'Handover protocol',
  POWER_OF_ATTORNEY: 'Power of attorney',
  PROPERTY_TAX_ASSESSMENT: 'Property tax assessment',
  VALUATION_REPORT: 'Valuation report',
  ACQUISITION_BRIEFING: 'Acquisition briefing',
  VALUATION: 'Valuation',
  FINANCING_CONFIRMATION: 'Financing confirmation',
  SELF_DISCLOSURE: 'Self-disclosure',
  CREDIT_REPORT: 'Credit check / SCHUFA',
  IDENTITY_DOCUMENT: 'Identification / ID (GwG)',
  INCOME_PROOF: 'Income proof',
  INSURANCE_CERTIFICATE: 'Insurance certificate',
  MISC: 'Miscellaneous',
  UNCATEGORIZED: 'Uncategorized',
} satisfies EnumTranslation<DocumentCategory>;
